<template>
    <ui-card-base with-border>
        <div class="page-cabinet-deals-item">
            <div class="page-cabinet-deals-item__headline">
                <div class="page-cabinet-deals-item__headline-image">
                    <common-image
                        v-bind:image="image"
                        v-bind:href="item.estate.url"
                    />
                </div>
                <div class="page-cabinet-deals-item__headline-info">
                    <div class="page-cabinet-deals-item__headline-info-estate"
                        v-text="item.estate.title"
                    />
                    <div class="page-cabinet-deals-item__headline-info-top-document"
                         v-if="document"
                    >
                        <ui-trigger
                            v-on:click="openDocumentModal"
                            text="Документы"
                            icon-left="legal-entity-i"
                            variant="dark"
                            is-underline-inverted
                            is-uppercase
                        />
                    </div>
                </div>
            </div>

            <div class="page-cabinet-deals-item__document" v-if="document">
                <ui-trigger
                    v-on:click="openDocumentModal"
                    text="Документы"
                    icon-left="legal-entity-i"
                    variant="dark"
                    is-underline-inverted
                    is-uppercase
                />
            </div>

            <div style="height: 8px"/>

            <template v-if="statusTheme">
                <div style="padding-left: 70px">
                    <ui-label
                        v-bind:title="item.statusFormatted"
                        v-bind:theme="statusTheme"
                        is-uppercase
                    />
                </div>
            </template>
            <template v-else>
                <ui-process :steps="steps" />
            </template>

            <div class="page-cabinet-deals-item__botline">
                <div class="page-cabinet-deals-item__botline-stats">
                    <div class="page-cabinet-deals-item__botline-stats-item"
                        v-for="(stat, i) in stats"
                        v-bind:key="i"
                        >
                        <div class="page-cabinet-deals-item__botline-stats-item-title"
                            v-text="stat.title"
                        />
                        <div class="page-cabinet-deals-item__botline-stats-item-value"
                            v-text="stat.value"
                        />
                    </div>
                </div>
                <div class="page-cabinet-deals-item__botline-actions"
                     v-if="item.status === 'wait_sign' || item.status === 'new' || isStatusFormRequired"
                >
                    <div class="page-cabinet-deals-item__botline-actions-item"
                        v-if="item.status === 'new'"
                        >
                        <ui-button
                            v-on:click="openInvestModal"
                            theme="primary"
                        >
                            Редактировать
                        </ui-button>
                    </div>
                    <div class="page-cabinet-deals-item__botline-actions-item"
                        v-if="isStatusFormRequired"
                        >
                        <ui-button
                            v-on:click="openStatusModal"
                            theme="primary"
                        >
                            Открыть счёт
                        </ui-button>
                    </div>
                    <div class="page-cabinet-deals-item__botline-actions-item"
                        v-else-if="item.status === 'wait_sign'"
                        >
                        <ui-button
                            v-bind:href="signUrl"
                            theme="primary"
                        >
                            Подписать
                        </ui-button>
                    </div>
                </div>
            </div>
        </div>
    </ui-card-base>
</template>

<script>
import utils from '~/utils';
import config from '~/config';
import { date as commonDateTransform } from '~/network/mainClient/common/transforms/responses';

export default {
    name: 'page-cabinet-deals-primary-item',
    props: {
        item: {
            type: Object,
        },
    },
    computed: {
        image() {
            return utils.common.injectResize(this.item.estate.image, '134x134');
        },
        stats() {
            return [
                { title: 'Дата', value: this.item.date },
                { title: 'Цена акции', value: this.item.priceFormatted },
                { title: 'Кол-во акций', value: this.item.quantity },
                { title: 'Сумма', value: this.item.amountFormatted },
            ];
        },
        steps() {
            return [
                {
                    title: 'Сбор заявок',
                    icon: 'spinner',
                    description: 'Пока идёт сбор заявок необходимо открыть счёт в реестродержателе «Статус».',
                    isCurrent: this.item.status === 'new',
                    instructionUrl: require('/static/docs/guide_buy.pdf'),
                },
                {
                    title: 'Подписание документов',
                    icon: 'pen',
                    description: 'Необходимо подписать документы, а если документы уже подписаны, дождитесь пока подпишут остальные инвесторы.',
                    isCurrent: this.item.status === 'wait_sign',
                },
                {
                    title: 'Начисление акций',
                    icon: 'receipt',
                    description: 'После начисления акций на лицевой счет в реестродержателе «Статус» акции появятся в личном кабинете.',
                    isCurrent: this.item.status === 'signed',
                },
                {
                    title: 'Проведена',
                    icon: 'check-thin',
                    description: '',
                    isCurrent: this.item.status === 'completed',
                },
            ];
        },
        statusTheme() {
            // if (this.isStatusFormRequired) {
            //     return 'warning';
            // }
            if (this.item.status === 'canceled' || this.item.status === 'refunded') {
                return 'negative';
            }
            if (this.item.status === 'completed') {
                return 'positive';
            }
            return null;
        },
        isStatusFormRequired() {
            return this.item.isStatusFormRequired;
        },
        document() {
            if (this.item.status === 'canceled' || this.item.status === 'refunded') {
                return null;
            }
            return this.item.documents && this.item.documents.length > 0;
        },
        signUrl() {
            return `${config.urls.cabinet.signRequest}${this.item.id}/`;
        },
    },
    methods: {
        openStatusModal() {
            this.$store.commit('modals/push', {
                name: 'status-form',
                props: {
                    estate: this.item.estate,
                },
            });
        },
        openDocumentModal() {
            this.$store.commit('modals/push', {
                name: 'download-docs',
                props: {
                    title: this.item.title || 'Документы для скачивания',
                    items: this.item?.documents?.map(item => ({
                        ...item,
                        created: commonDateTransform(item.created),
                    })),
                },
            });
        },
        openInvestModal() {
            this.$store.commit('modals/push', {
                name: 'invest',
                props: {
                    isReApply: true,
                    estateId: this.item.estate.id,
                    currentInvestmentRequestId: this.item.id,
                    onClose: () => {
                        this.$store.dispatch('investments/getRequests', {
                            status__in: 'new,wait_sign,signed,waiting,completed',
                            ordering: '-modified',
                        });
                    },
                },
            });
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-deals-item {
    padding: 8px;
    &__headline {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        &-image {
            flex: 0 0 auto;
            width: 54px;
            height: 54px;
            margin-right: 16px;

            @media @media-sm-down {
                width: 48px;
                height: 48px;
                margin-right: 12px;
            }
        }
        &-info {
            flex: 1 1 auto;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            &-top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                margin-bottom: 8px;
                &-status {
                    flex: 0 1 auto;
                }
                &-document {
                    .typography-caption();

                    flex: 0 1 auto;
                }
            }
            &-estate {
                .typography-medium();
            }
        }
    }
    &__botline {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 16px;
        border-top: 1px solid @color-gray-light;
        padding-top: 24px;
        &-stats {
            flex: 0 0 auto;
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
            gap: 8px;
            width: 100%;
            max-width: 569px;

            &-item {
                .typography-body();

                flex: 0 0 auto;

                &-title {
                    margin-bottom: 8px;

                    color: @color-gray-main;
                }
            }
        }
        &-actions {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 24px;
            &-item {
                flex: 0 0 auto;
                width: fit-content;
            }
        }
    }
    &__document {
        display: none;
        width: 120px;
        margin-left: 70px;
        padding: 8px 0;

        @media @media-sm-down {
            margin-left: 60px;
        }
    }
    @media @media-xl-down {
        &__botline {
            flex-direction: column;
            align-items: flex-start;
            &-actions {
                padding-top: 24px;
                width: 100%;
                justify-content: center;
            }
        }
    }
    @media @media-xl-down {
        padding: 0;
        &__headline {
            &-info {
                justify-content: flex-start;
                &-top {
                    margin-bottom: 4px;
                    &-document {
                        display: none;
                    }
                }
                &-estate {
                    .typography-heading();
                }
            }
        }
        &__botline {
            padding-top: 16px;
            &-actions {
                flex-direction: column;
                &-accept {
                    width: 100%;
                    max-width: 280px;
                    margin: 0 auto 24px;
                }
                &-cancel {
                    margin: 0 auto;
                    width: fit-content;
                }
            }
        }
        &__document {
            .typography-caption();

            display: block;
            width: fit-content;
        }
    }
}
</style>
